import { useState, useEffect } from 'react';
import API_ROUTES from './apiRoutes';
import { useFetch } from './useFetch';

export const useSingleContent = (contentId) => {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    const { fetchWithAuth } = useFetch();

    const getToken = () => localStorage.getItem("token");

    useEffect(() => {
        const fetchContent = async () => {
            if (!contentId) {
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                const response = await fetchWithAuth(API_ROUTES.CONTENTS.get(contentId), {
                    method: 'GET',
                    headers: {
                        "Authorization": `Bearer ${getToken()}`,
                        'Content-Type': 'application/json',
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch content');
                }

                const data = await response.json();
                
                // Transform the data to match the expected format
                const transformedContent = {
                    id: data.content.content_id,
                    contentId: data.content.content_id,
                    title: data.content.content_title,
                    subtitle: data.content.content_subtitle,
                    description: data.content.content_description,
                    url: data.content.content_url,
                    thumbnailUrl: data.content.content_thumbnail_url,
                    additionalInfo: data.content.content_additional_info,
                    status: data.content.content_is_blocked ? 'blocked' : 'available',
                    type: data.content.content_type || 'video',
                    templateId: data.content.content_template_id,
                    access: data.content.content_access,
                    createdAt: data.content.content_created_at,
                    updatedAt: data.content.content_updated_at
                };

                setContent(transformedContent);
            } catch (err) {
                setError(err.message || "Error loading content");
            } finally {
                setLoading(false);
            }
        };

        fetchContent();
    }, [contentId, fetchWithAuth]);

    return { content, loading, error };
};
